// Zustand store for the aggregates filter form state. The form itself is
// driven by react-hook-form + zod (see FilterBar); this store holds the
// *submitted* filters that the TanStack Query hooks read, so live data is
// refetched only when the user submits, not on every keystroke.

import { create } from 'zustand'
import type { AggregatesFilters } from '../types/gateway'

interface FilterState extends AggregatesFilters {
  setFilters: (next: AggregatesFilters) => void
  reset: () => void
}

const EMPTY: AggregatesFilters = { from: null, to: null, route: null, model: null }

export const useFilterStore = create<FilterState>((set) => ({
  ...EMPTY,
  setFilters: (next) => set({ from: next.from, to: next.to, route: next.route, model: next.model }),
  reset: () => set({ ...EMPTY }),
}))

// Selector helper returning a stable filters object reference for query keys.
export function selectFilters(s: FilterState): AggregatesFilters {
  return { from: s.from, to: s.to, route: s.route, model: s.model }
}
